import React, { Component } from 'react';
import clsx from 'clsx';
import Message from './ValidationMessage';
import InlineField from './InlineField';

export class TextField extends Component {
  render() {
    let {
      action,
      autoFocus,
      disabled,
      displayType,
      icon,
      actionLabel,
      id,
      input,
      intl,
      label,
      meta: { error, touched, warning },
      onKeyPress,
      options = {},
      placeholder,
      required,
      simple,
      translation,
      type,
      width,
      hideError = false,
    } = this.props;

    if (simple) {
      return <Simple {...this.props} />;
    }

    if (displayType === 'inline') {
      return (
        <InlineField
          fieldType="renderField"
          translation={translation}
          content={input.value}
          label={label}
          id={id}
        />
      );
    }

    if (intl && translation) {
      const labelObj = translation.label;
      const placeholderObj = translation.placeholder;
      if (labelObj && labelObj.message) {
        label = intl.formatMessage(labelObj.message, labelObj.params);
      }
      if (placeholderObj && placeholderObj.message) {
        placeholder = intl.formatMessage(
          placeholderObj.message,
          placeholderObj.params,
        );
      }
    }

    return (
      <div
        className={clsx('field', {
          required: required,
          error: touched && error,
          [width + ' wide']: width,
        })}
      >
        {label && <label>{label}</label>}
        <div className={clsx('ui input', { action: Boolean(action) })}>
          <input
            {...input}
            autoFocus={autoFocus}
            disabled={disabled}
            id={id}
            onKeyPress={onKeyPress}
            placeholder={placeholder}
            readOnly={options.readOnly || false}
            type={type}
          />

          {action && (
            <button
              type="button"
              onClick={action}
              disabled={disabled}
              className={clsx('ui basic button', {
                red: touched && error,
                icon: icon,
                labeled: icon && actionLabel,
              })}
            >
              {actionLabel}
              {icon && <i className={`${icon} icon`} />}
            </button>
          )}
        </div>

        {!hideError && <Message show={touched} message={error} />}
        <Message show={touched} message={warning} />
      </div>
    );
  }
}

const Simple = props => {
  const { input, disabled, placeholder, type, id } = this.props;
  return (
    <input
      {...input}
      type={type}
      placeholder={placeholder}
      disabled={disabled}
      id={id}
    />
  );
};

export const APLHA = () => {
  return value => {
    if (!value) {
      return value;
    }
    return value.replace(/[^a-z]/gi, '');
  };
};
export const ALPHANUMERIC = () => {
  return value => {
    if (!value) {
      return value;
    }
    return value.replace(/[^a-z0-9]/gi, '');
  };
};
